module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search",
    on: {
      "scroll": _vm.onScroll
    }
  }, [_c('div', {
    staticClass: "search-top"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.defaultKey),
      expression: "defaultKey"
    }],
    attrs: {
      "type": "search",
      "name": "search-input",
      "placeholder": (typeof _vm.defaultKey == 'object' && _vm.defaultKey && _vm.defaultKey.name) || '搜索全网商品'
    },
    domProps: {
      "value": (_vm.defaultKey)
    },
    on: {
      "focus": _vm.focusInput,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.defaultKey = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "search-cancel",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")])]), _vm._v(" "), (_vm.isSearch) ? _c('div', {
    staticClass: "result-list"
  }, [_c('nav-bar', {
    staticClass: "p-nav-bar",
    attrs: {
      "query": ("keyword=" + _vm.key),
      "type": 'search'
    },
    on: {
      "navshow": _vm.navshow,
      "action": _vm.action,
      "list": _vm.list
    }
  }), _vm._v(" "), (!_vm.seaching && !_vm.items.length) ? _c('div', {
    staticClass: "empty"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/icon-empty.png")
    }
  }), _vm._v(" "), _c('p', [_vm._v("没有搜索到你要的结果")])]) : _vm._e(), _vm._v(" "), _c('search-list', {
    attrs: {
      "data": _vm.items,
      "keys": _vm.key,
      "suggest": _vm.suggest
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "go-cart",
    on: {
      "click": _vm.goCart
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isAssociate && !_vm.isCouponSearch) ? _c('associate-list', {
    attrs: {
      "list": _vm.associateList,
      "aKey": _vm.aKey
    },
    on: {
      "selectItem": _vm.search
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isSearch && !_vm.isCouponSearch) ? _c('div', {
    staticClass: "search-key"
  }, [(_vm.history.length > 1) ? _c('div', {
    staticClass: "latest-key"
  }, [_c('span', {
    staticClass: "search-clear",
    on: {
      "click": _vm.clearSearch
    }
  }), _vm._v(" "), _c('h2', [_vm._v("搜索历史")]), _vm._v(" "), _c('ul', {
    attrs: {
      "id": "history-key"
    }
  }, [_vm._l((_vm.history), function(item, index) {
    return (item && index < _vm.maxIndex) ? _c('li', {
      on: {
        "click": function($event) {
          return _vm.goSearch(item, '历史词')
        }
      }
    }, [_vm._v(_vm._s(item) + " ")]) : _vm._e()
  }), _vm._v(" "), (_vm.hideMore && _vm.history.length > 6) ? _c('li', {
    staticClass: "item-more",
    on: {
      "click": _vm.showMoreHist
    }
  }) : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), (_vm.hotItem && _vm.hotItem.hotKeys.length > 0) ? _c('div', {
    staticClass: "hot-key"
  }, [_c('h2', [_vm._v("热门发现")]), _vm._v(" "), _c('ul', _vm._l((_vm.hotItem.hotKeys), function(item) {
    return _c('li', {
      class: {
        'high-light': item.highlight
      },
      on: {
        "click": function($event) {
          return _vm.goLink(item, true, '热门搜索')
        }
      }
    }, [_c('i'), _vm._v(_vm._s(item.name) + " ")])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.banners.length) ? _c('div', {
    staticClass: "search-banner"
  }, _vm._l((_vm.banners), function(banner) {
    return _c('div', {
      staticClass: "img-item",
      on: {
        "click": function($event) {
          return _vm.jumpBanner(banner.link)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": banner.src
      }
    })])
  }), 0) : _vm._e()]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26735406"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./static/components/search/components/main.vue
// module id = 224
// module chunks = 1 2 3 4 5 6 7 8 9 10 12 13 14 16 17 19 21 26 28 29 31 36 37 40 42